/**
 * Cloudflare Images base url, supports transformations. Used only for images.
 * https://developers.cloudflare.com/images/transform-images/transform-via-url/
 * Example: https://image.bridebook.com/assets/cms/supplier-pro/bridebook-team.jpg/w=250
 */
export const IMAGES_BASE_URL = 'https://image.bridebook.com';
export const BB_USER_IMAGES_BASE_URL = 'https://bb-user-images.bridebook.com';
export const PROXY_IMAGES_URL = 'https://bridebook.com/cdn-cgi/image';

/**
 * R2 bucket of static assets. Migrated from bridebook-imgs S3. Used for non-images static assets.
 */
export const ASSETS_BASE_URL = 'https://media.bridebook.com/assets';

export default function buildImageUrl({
  public_id,
  ext,
}: {
  public_id: string;
  ext: string;
}): string {
  return `${IMAGES_BASE_URL}/${public_id}.${ext}`;
}
